import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-purple-400 text-xl">Chargement...</div>
      </div>
    );
  }

  // Guest role - accessible to everyone (even non-logged in users)
  if (requiredRole === 'guest') {
    return children;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check role requirements
  if (requiredRole === 'admin' && !['admin', 'superadmin'].includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-center space-y-4">
          <h2 className="text-2xl font-bold text-red-400">Accès refusé</h2>
          <p className="text-gray-400">Cette page est réservée aux administrateurs.</p>
        </div>
      </div>
    );
  }

  if (requiredRole === 'member' && !['member', 'admin', 'superadmin'].includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="max-w-md text-center space-y-6">
          <div className="w-20 h-20 mx-auto bg-purple-900/50 rounded-full flex items-center justify-center border-2 border-purple-500/50">
            <svg className="w-10 h-10 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-purple-300">Compte en cours de vérification</h2>
          <p className="text-gray-300">
            Bienvenue ! Votre inscription a bien été prise en compte.
          </p>
          <p className="text-gray-400">
            Un administrateur va valider votre compte très prochainement. 
            Vous recevrez l'accès à l'espace membre dès que votre compte sera activé.
          </p>
          <div className="pt-4 border-t border-purple-500/30">
            <p className="text-gray-500 text-sm">
              Une question ? Contactez-nous :
            </p>
            <a 
              href="mailto:association@justroleit.fr" 
              className="text-purple-400 hover:text-purple-300 font-semibold transition-colors"
            >
              association@justroleit.fr
            </a>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;